import { isTauri } from "@/lib/is-tauri";
import { useCanvasStore } from "@/stores/canvas-store";
import { useDesktopMode } from "@/stores/desktop-mode-store";

/** The hand tool persists; the configured native pan gesture temporarily enables it. */
export function useCanvasPanMode(): boolean {
  const handActive = useCanvasStore((state) => state.isPanMode);
  const optionHeld = useDesktopMode(
    (state) => state.mode === "denk" && state.denkWorkspacePreview,
  );
  return handActive || (isTauri() && optionHeld);
}
